module.exports = __webpack_public_path__ + "img/WechatIMG865.c8c4a91c.png";